import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  public menuContent: any;
  constructor(private http: HttpClient) { }
  public eskaCoreMenus: any[] = [];
  private eskaCoreMenuContent = new BehaviorSubject<any[]>(this.eskaCoreMenus);
  data = this.eskaCoreMenuContent.asObservable();

  public isCoreIntegration(): boolean {
    const isIntegration = localStorage.getItem('coreIntegration');
    if (isIntegration === 'true') {
      return true;
    }
    return false;
  }

  public updateEskaCoreMenus(data: any[]) {
    this.eskaCoreMenuContent.next(data);
  }
  public getCoreMenus(token: string) {
    return this.http.get<any>(
      `/EskaCoreIntegrationApi/GetAllMenus?token=${token}`
    );
  }

  public getDepartmentsByTopic(topic: string) {
    return this.http.get<any>(
      `/customergroups/GetGroupsByTopic/${topic}`
    );
  }

}
